module.exports = __webpack_public_path__ + "static/media/feature-interview-offer@2x.485dde85.png";